import { LazyBreadcrumb, useDumbActionsContext } from '@europrocurement/flexy-components';
import React from 'react';
import { useDefaultContextActions } from '@europrocurement/l2d-modules';
import PrescriberForm from './form/PrescriberForm';

const PrescripteurAdd: React.FunctionComponent = function () {
    const { backContextActions } = useDefaultContextActions();
    useDumbActionsContext(backContextActions);

    return (
        <>
            <LazyBreadcrumb
                path={[
                    { path: 'Prescripteurs', link: '/prescripteurs/new' },
                    'Nouveau prescripteur',
                    'Création de prescripteur',
                ]}
            />

            <PrescriberForm />
        </>
    );
};

export default React.memo(PrescripteurAdd);
